import React from 'react';
import { costRows } from '../data/content';
export function CostOfWaiting() {
  return <section className="w-full bg-white" data-id="element-48" data-mp="3a5w5qgxb148k">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-49" data-mp="3a6xj4s1sm2tg">
        <div className="max-w-3xl" data-id="element-50" data-mp="2w74ur3dqnyon">
          <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-51" data-mp="2w87jp5ri3r1x">
            ¿Cuánto cuesta seguir igual?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-52" data-mp="3ouijie7a9nxo">
            No podés controlar todos los cambios de la economía, pero sí podés
            aprender a administrar mejor tus recursos y prepararte para lo que
            venga.
          </p>
        </div>

        <div className="mt-10 overflow-hidden rounded-2xl border border-line" data-id="element-53" data-mp="3k4bwgisf6bhj">
          <table className="w-full text-left" data-id="element-54" data-mp="3k27i16ww9u30">
            <caption className="sr-only" data-id="element-55" data-mp="bo8o0athgis5">
              Comparación entre seguir sin sistema y su costo real
            </caption>
            <thead className="bg-cream-deep" data-id="element-56" data-mp="ggs1z8w31fxh">
              <tr data-id="element-57" data-mp="3l8bg7h6dwslm">
                <th scope="col" className="px-6 py-4 font-display text-xs font-bold uppercase tracking-wide text-ink-muted" data-id="element-58" data-mp="3l7tbdw5np623">
                  Hoy, sin sistema
                </th>
                <th scope="col" className="px-6 py-4 font-display text-xs font-bold uppercase tracking-wide text-ink-muted" data-id="element-59" data-mp="3uy4g3kx5zja1">
                  Lo que te cuesta
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-60" data-mp="8qemo99qk4h6">
              {costRows.map(row => <tr key={row.situation} className="align-top" data-id="element-61" data-mp="3s38xngbl9to">
                  <th scope="row" className="w-1/2 px-6 py-5 text-base font-semibold text-ink" data-id="element-62" data-mp="3rtkw5eu5cqm">
                    {row.situation}
                  </th>
                  <td className="px-6 py-5 text-base text-ink-muted" data-id="element-63" data-mp="cs9iwzct7ro3">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-10 max-w-2xl font-display text-2xl font-extrabold leading-snug text-forest sm:text-3xl" data-id="element-64" data-mp="2eknz9tzpgo2e">
          El cambio no empieza cuando ganás más. Empieza cuando sabés qué hacer
          con lo que entra.
        </p>
      </div>
    </section>;
}